import { render, staticRenderFns } from "./OrderExpired.vue?vue&type=template&id=593d9fc4&scoped=true&"
import script from "./OrderExpired.vue?vue&type=script&lang=js&"
export * from "./OrderExpired.vue?vue&type=script&lang=js&"
import style0 from "./OrderExpired.vue?vue&type=style&index=0&id=593d9fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593d9fc4",
  null
  
)

export default component.exports